export const FIFTEEN_MINUTES = 15 * 60 * 1000;
export const THIRTY_MINUTES = 2 * FIFTEEN_MINUTES;
